import React from "react";
import { Col, Row } from "react-bootstrap";

const AboutChild_Education = (props) => {
  return (
    <>
      <h2 className="m-0 pb-3">My Education</h2>
      <hr />
      <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2012-2016</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">MCA</h5>
          <span>L.J. Institute of Computer Applications(GTU)</span>
        </Col>
      </Row>
      <hr />
      <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2009-2012</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">BCA</h5>
          <span>St. Xavier's college(GU)</span>
        </Col>
      </Row>
      <hr />
      <Row className="py-3">
        <Col md={5} xs={5}>
          <h6 className="title-primary">2017-2019</h6>
        </Col>
        <Col md={7} xs={7}>
          <h5 className="title-primary">D.El.Ed.</h5>
          <span>NIOS (Govt. of India)</span>
        </Col>
      </Row>
      <hr />
    </>
  );
};

export default AboutChild_Education;
